/* eslint-disable */
import { toCamelCaseProperties, replaceEmojiisWithText } from '@/utils/fn';
import moment from '@/plugins/moment';

export default class GiftCardPurchaseDetails {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.giftcardId = args.giftcardId;
		this.createdDate = moment(args.createdDate || '');
		this.expirationDate = moment(args.expirationDate || '');
		this.activated = args.activated;
		this.externalGiftcardId = args.externalGiftcardId || '';

		// Receiver
		this.receiverFirstName = args.receiverFirstName || '';
		this.receiverLastName = args.receiverLastName || '';
		this.receiverMobile = args.receiverMobile || '';
		this.deliveryAddress = args.deliveryAddress || '';
		this.deliveryPostalCode = args.deliveryPostalCode || '';
		this.deliveryPostalArea = args.deliveryPostalArea || '';
		this.deliveryToReceiver = args.deliveryToReceiver || 0;
		this.deliveryMethod = args.deliveryMethod || 0;
		
		this.personalMessage = args.personalMessage || '';
		this.personalMessageFrom = args.personalMessageFrom || '';
		this.personalMessageTo = args.personalMessageTo || '';
		
		// this.personalMessage = replaceEmojiisWithText(args.personalMessage) || '';
		// this.personalMessageFrom = replaceEmojiisWithText(args.personalMessageFrom) || '';
		// this.personalMessageTo = replaceEmojiisWithText(args.personalMessageTo) || '';

		this.deliveryEmail = args.deliveryEmail || '';
		this.deliveryPhoneNumber = args.deliveryPhoneNumber || '';
		this.deliverySMSTime = moment(args.deliverySMSTime || new Date());


		// GiftCard
		this.amount = args.amount || 0;

		// Payment
		this.paymentMethodId = args.paymentMethodId || '';

		// Order
		this.orderType = args.orderType || 1;
	}

	get isCancelable() {
		return !this.activated;
	}
}

export class GiftCardPurchaseResult {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		let paymentResponse = toCamelCaseProperties(args.paymentResponse) || {};

		this.shoppingCartId = args.shoppingCartId;
		this.paymentIntentClientSecret = paymentResponse.paymentIntentClientSecret;
		this.paymentRequiresAction = !!paymentResponse.requiresAction;
		this.paymentResponseCode = paymentResponse.responseCode;
		this.responseCode = args.responseCode;
		this.responseMessage = args.responseMessage;
		this.externalGiftCardId = args.externalGiftCardId;
	}

	get completed() {
		return this.responseCode === 200;
	}

	get failed() {
		return !(this.completed || (this.paymentIntentClientSecret && this.paymentRequiresAction));
	}

	// An error occured after fulfilled payment causing placement of gift card order to fail. Needs internal handling.
	get requiresInternalHandling() {
		return [703, 704].includes(this.responseCode);
	}

	get message() {
		switch (this.responseCode) {
			case 200: // Ok
				return 'Kjøp av gavekort vellykket!';
			case 206: // Payment required additional action (3D-Secure)
				return 'Betalingsoppgave opprettet, men det kreves ytterligere tiltak for å fullføre betalingen.';
			case 400:
				return this.responseMessage;
			case 401:
				return 'Du er ikke lenger logget inn. Logg inn og prøv på nytt.';
			case 700:
				return 'Validering mislyktes. Pass på at all informasjon er riktig utfylt.';
			case 701: // Failed to process shopping cart
				return 'Kjøp av gavekort feilet. En intern feil oppstod. Vennligst prøv igjen.';
			case 702: // Payment failed
				switch (this.paymentResponseCode) {
					case 207:
						return 'Betaling feilet. Kan ikke belaste kort. Feil eller ingen dekning på kort.';
					case 401:
						return 'Betaling feilet. Kan ikke autorisere deg i forespørselen. Vennligst prøv på nytt.';
					case 506:
						return 'Betaling feilet. Ingen kontakt med betalingstjeneste. Vennligst prøv på nytt senere.';
					case 700:
						return 'Betaling feilet. Validering av kort mislyktes. Pass på at all informasjon er riktig utfylt.';
					default:
						return 'Betaling feilet. Vennligst prøv igjen eller bruk et annet betalingsmiddel.';
				}
			case 703: // Critical: Payment succeeded, but failed to process gift card.
			case 704: // Critical: Payment and gift card process succeeded, but failed to place order.
				return 'Kjøp av gavekort vellykket, men ordre er ikke blitt plassert enda. Du vil få en ordre-bekreftelse på mobil/e-post når dette er plassert. Ved spørsmål, kontakt Fixit Kundesenter på telefon: 55 70 70 60.';
			case 207:
			case 500:
			default:
				if (this.paymentResponseCode === 200) {
					// Critical: Payment succeeded. But an unexpected error occured.
					return 'Kjøp av gavekort vellykket, men ordre er ikke blitt plassert enda. Du vil få en ordre-bekreftelse på mobil/e-post når dette er plassert. Ved spørsmål, kontakt Fixit Kundesenter på telefon: 55 70 70 60.';
				}
				return 'En uventet feil oppstod. Vennligst prøv igjen.';
		}
	}
}

export class GiftCardDeliveryOption {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.deliveryMethod = args.deliveryMethod;
		this.title = args.title || '';
		this.description = args.description || '';
		this.priceIncVat = args.priceIncVat || 0;
		this.imageUrl = args.imageUrl || '';
		this.icon = args.icon || '';
		this.portraitImageUrl = args.portraitImageUrl || '';
	}
}

export class GiftCardPersonalMessage {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.text = args.text || '';
		this.message = args.message || '';
	}
}

export class GiftCardWrappingOption {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.giftCardWrappingType = args.giftCardWrappingType;
		this.title = args.title || '';
		this.description = args.description || '';
		this.priceIncVat = args.priceIncVat || 0;
		this.imageUrl = args.imageUrl || '';
		this.icon = args.icon || '';
	}
}
